import React from "react";
import "../css/Loader.css";

function Loader() {
  return (
    <div className="global-loader">
      <div className="spinner"></div>
    </div>
  );
}

export default Loader;
